import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { Subscription } from 'rxjs';
import { generateGuid } from 'src/app/helpers/helpers';
import { gridItem, property } from 'src/app/models';
import { SharedSortService } from '../../widget/widget-utilities/shared-sort.service';

@Component({
    selector: 'app-sort-select',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.scss'],
    standalone: false
})
export class SortComponent implements OnChanges, OnInit, OnDestroy {

  @Input() properties: Array<property> = [];
  @Input() gridItem: gridItem;
  @Input() items: Array<number> = [];
  @Input() isSecondSorting: boolean = false;
  selectedProperties: Array<property> = [];
  isSortByOpen: boolean;
  radioButtonName: string;
  radioButtonAscId: string;
  radioButtonDescId: string;
  sortBySubscription: Subscription;

  public static firstLevelSetupColumnPropertyName = "sortBy";
  public static secondLevelSetupColumnPropertyName = "sortBy2";
  public static firstLevelSetupDirectionPropertyName = "sortDirection";
  public static secondLevelSetupDirectionPropertyName = "sortDirection2";

  get sortByPropertyName(): string {
    return this.isSecondSorting ? SortComponent.secondLevelSetupColumnPropertyName : SortComponent.firstLevelSetupColumnPropertyName;
  }

  get sortDirectionPropertyName(): string {
    return this.isSecondSorting ? SortComponent.secondLevelSetupDirectionPropertyName : SortComponent.firstLevelSetupDirectionPropertyName;
  }

  get titleText(): string {
    let text = this.isSecondSorting ? "Then Sort By" : "Sort By";
    return this.i18nextPipe.transform("dashboard:" + text);
  }

  constructor(private i18nextPipe: I18NextPipe, private sharedSortService: SharedSortService) {
    this.radioButtonName = "sortDirection_" + generateGuid();
    this.radioButtonAscId = "sortDirectionAsc_" + generateGuid();
    this.radioButtonDescId = "sortDirectionDesc_" + generateGuid();    
  }    

  ngOnChanges(changes: SimpleChanges) {
    this.selectedProperties = this.properties?.filter(p => this.items?.includes(p.id)) ?? [];
    this.selectedProperties.unshift({ name: "Name", id: -1 });

    if (this.isSecondSorting && this.gridItem.setup[SortComponent.firstLevelSetupColumnPropertyName] != null) {
      this.selectedProperties = this.selectedProperties.filter(sp => sp.name != this.gridItem.setup[SortComponent.firstLevelSetupColumnPropertyName]);
    }

    if (this.selectedProperties.length > 1 && this.selectedProperties.filter(p => p.name == this.gridItem.setup[this.sortByPropertyName]).length == 0) {
      this.gridItem.setup[this.sortByPropertyName] = null;
      this.gridItem.setup[this.sortDirectionPropertyName] = null;
    }
  }

  ngOnInit(): void {
    if (this.isSecondSorting) {
      this.sortBySubscription = this.sharedSortService.sortBy$.subscribe((value) => {
        // handle change of sortBy
        this.ngOnChanges(null);
      });
    }
  }

  ngOnDestroy(): void {
    this.sortBySubscription?.unsubscribe();
  }

  sortByChanged(): void {
    if (this.gridItem.setup[this.sortByPropertyName] != null && this.gridItem.setup[this.sortDirectionPropertyName] == null) {
      this.gridItem.setup[this.sortDirectionPropertyName] = 0;
    }

    if (!this.isSecondSorting) {
      const newSortByValue = this.gridItem.setup[SortComponent.firstLevelSetupColumnPropertyName];
      this.sharedSortService.updateSortBy(newSortByValue);
    }
  }

  sortByClear(): void {
    this.gridItem.setup[this.sortByPropertyName] = null;
    this.gridItem.setup[this.sortDirectionPropertyName] = null;
  }

  sortDirectionChanged(ev): void {
    this.gridItem.setup[this.sortDirectionPropertyName] = parseInt(ev.target.value);
  }
}
